import React from 'react';
import { BiCoinStack, BiUserX } from 'react-icons/bi';
import { FaHandHoldingDollar } from 'react-icons/fa6';
import { HiUserGroup } from 'react-icons/hi2';
import { IoWalletOutline } from 'react-icons/io5';
import { LiaClipboardListSolid, LiaMoneyBillSolid, LiaMoneyBillWaveSolid } from 'react-icons/lia';
import { LuCalendarCheck } from 'react-icons/lu';
import { TbUser, TbUserCheck, TbUsersGroup } from 'react-icons/tb';
import LineChart from './charts/LineChart';
import BarChart from './charts/barChart';

function Dashboard() {
  const users = [
    { icons : <TbUsersGroup /> , id:  1, status: 1350  , about: 'Total Users'},
    { icons : <TbUserCheck /> , id:  2, status: 1340 , about: 'Total Verified Users'},
    { icons : <BiUserX /> , id:  3, status: 10 , about: 'Total Unverified Users'},
    { icons : <TbUser /> , id:  4, status: 300 , about: 'Total Banned Users'}, 
    { icons : <IoWalletOutline /> , id:  5, status: '$ 36,008.00' , about: 'Total Pridicted Amount'}, 
    { icons : <FaHandHoldingDollar /> , id:  6, status: '$ 0.00' , about: 'Total Refund Amount'}, 
    { icons : <LuCalendarCheck /> , id:  7, status: '$ 835.00' , about: 'Total Return Amount'},
    { icons : <BiCoinStack /> , id:  8, status: '$ 35,173.00' , about: 'Total Profit From Prediction'},
    { icons : <LiaClipboardListSolid /> , id:  9, status: '210' , about: 'Total Deposit'}, 
    { icons : <LiaMoneyBillSolid /> , id:  10, status: '0' , about: 'Total Deposit Charge'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  11, status: '12' , about: 'Pending Deposit'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  12, status: '0 USD' , about: 'This Month Deposit'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  13, status: '100' , about: 'Total Withdraw'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  15, status: '0' , about: 'Total Withdraw Charge'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  16, status: '113' , about: 'Pending Withdrawals'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  17, status: '0 USD' , about: 'This Month Withdraw'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  18, status: '57' , about: 'Running Tournament'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  19, status: '8' , about: 'Running Event'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  20, status: '487' , about: 'Closed Event'}, 
    { icons : <LiaMoneyBillWaveSolid  /> , id:  21, status: '$ 0.00' , about: 'Total Charge From Winner'}, 
  ];

  return (
    <main className='px-4 mt-4'>
      <h4 className='header-title pb-3 text-muted'>Dashboard</h4>
      <div className='row '>
        {users.map((user, index) => (
          <div className='col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3' key={index}>
            <div className='card  custom-card-hover '>
              <div className='card-body d-flex  justify-content-between align-items-center'>
               <div className='my-1'>
               <p className='mb-2 fw-semibold'>{user.about}</p>
               <h3 className='mb-2 fw-semibold text-muted'>{user.status}</h3>
               </div>
                <p className='mb-0 cards-custom-icons'>
                  {user.icons}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

          <div className="row">

            <div className="col-12 col-md-6 col-lg-6">
              <div className="card card-shadow-blue pointer">
                <div className="card-body">
                  <div className="d-flex flex-column align-items-center">
                  <div style={{ width: '100%', height: 'auto' }}> 
                    <BarChart/> 
                  </div> 
                  <p className='fs-6 fw-bold mt-3 text-center mb-0'>
                    Total Instant Cash (Last 4 Months)
                  </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="card card-shadow-blue pointer">
                <div className="card-body">
                  <div className="d-flex flex-column align-items-center">
                    <div style={{ width: '100%', height: 'auto' }}>
                      <LineChart/>
                    </div>
                    <p className='fs-6 fw-bold mt-3 text-center mb-0'>
                      Betting Statistics (Last 12 Months)
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
    </main>

  );
}
export default Dashboard;